import React, { Fragment, useState } from 'react'
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import VerInfoDelAsociadoComponent from './VerInfoDelAsociadoComponent';
import DiasDeLaLocalidadComponent from './DiasDeLaLocalidadComponent';
import DesvincularAsociadoDeLocalidadComponent from './DesvincularAsociadoDeLocalidadComponent';
import AsociadoItemComponent from './AsociadoItemComponent';
import { activarAsociado } from '../../../redux/DucksUnidadInspeccion/ZonasDuck'
import { useDispatch } from 'react-redux'
import Backdrop from '@mui/material/Backdrop';
import ModalUnstyled from '@mui/base/ModalUnstyled';
import AsociadoFormComponent from './AsociadoFormComponent';
import { obtenerAsociadosLocalidadByIdSublocalidad } from '../../../redux/DucksUnidadInspeccion/AsociadosEnLaLocalidadDuck';

import { useSelector } from 'react-redux'

function AsociadosDeLaLocalidadListComponent(props) {

    const asociados = props.asociados;
    const localidad = props.localidad
    const sublocalidad = props.sublocalidad
    const zona = props.zona

    const dispatch = useDispatch()

    const styleModalAgregar = {
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
        width: 800, bgcolor: 'white', border: '2px solid #000', boxShadow: 24, p: 4,
    };

    const styleModalDias = {
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
        width: 800, bgcolor: 'white', border: '2px solid #000', boxShadow: 24, p: 4,
    };

    const styleModalVerInfoDelAsociado = {
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
        width: 800, bgcolor: 'white', border: '2px solid #000', boxShadow: 24, p: 4,
    };

    const styleModalConfirmacion = {
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
        width: 500, bgcolor: 'white', border: '2px solid #000', boxShadow: 24,
        p: 4, fontSize: '20px', textAlign: 'center'
    };

    const [asociadoAux, setAsociadoAux] = React.useState(null)

    const [openModalVerInfoDelAsociado, setOpenModalVerInfoDelAsociado] = React.useState(false);

    // React.useEffect(() => {
    //     dispatch(obtenerAsociadosLocalidadByIdSublocalidad(sublocalidad.idsublocalidad))
    // }, [])

    const actualizarAsociadosLocalidad = () => {
        // dispatch(obtenerAsociadosLocalidadByIdSublocalidad(sublocalidad.idsublocalidad))
    }

    const handleOpenModalVerInfoDelAsociado = (asociado) => {
        setOpenModalVerInfoDelAsociado(true);
        setAsociadoAux(asociado)
    }
    const handleCloseModalVerInfoDelAsociado = () => setOpenModalVerInfoDelAsociado(false);

    const [openModalAgregarInstalacion, setOpenModalAgregarInstalacion] = React.useState(false);
    const handleOpenModalAgregarInstalacion = () => {
        setOpenModalAgregarInstalacion(true)
    }
    const handleCloseModalAgregarInstalacion = () => setOpenModalAgregarInstalacion(false);

    const [openModalReagendarDiasDelAsociado, setOpenModalReagendarDiasDelAsociado] = React.useState(false);
    const handleOpenModalReagendarDiasDelAsociado = (asociado) => {
        setOpenModalReagendarDiasDelAsociado(true);
        setAsociadoAux(asociado)
    }
    const handleCloseModalReagendarDiasDelAsociado = () => setOpenModalReagendarDiasDelAsociado(false);


    const [openModalDesvincularAsociado, setOpenModalDesvincularAsociado] = React.useState(false);
    const handleOpenModalDesvincularAsociado = (asociado) => {
        setOpenModalDesvincularAsociado(true);
        setAsociadoAux(asociado)
    }
    const handleCloseModalDesvincularAsociado = () => setOpenModalDesvincularAsociado(false);


    const [openModalActivarAsociado, setOpenModalActivarAsociado] = React.useState(false);
    const handleOpenModalActivarAsociado = (asociado) => {
        setOpenModalActivarAsociado(true);
        setAsociadoAux(asociado)
    }
    const handleCloseModalActivarAsociado = () => setOpenModalActivarAsociado(false);

    const activarUsuario = (asociadoAux) => {
        const data = [{ asociado: asociadoAux.id, zona: zona.id, localidad: localidad.id }]

        dispatch(activarAsociado(data))
        setOpenModalActivarAsociado(false)
    }

    const modalDesvincularAsociado = () => {
        return (
            <Modal
                open={openModalDesvincularAsociado}
                onClose={handleCloseModalDesvincularAsociado}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                <Box sx={styleModalAgregar}>
                    <DesvincularAsociadoDeLocalidadComponent onClose={handleCloseModalDesvincularAsociado} zona={zona} localidad={localidad} asociado={asociadoAux}></DesvincularAsociadoDeLocalidadComponent>
                </Box>
            </Modal>
        )
    }

    const modalAgregarInstalacionAsociado = () => {
        return (
            <Modal
                open={openModalAgregarInstalacion}
                onClose={handleCloseModalAgregarInstalacion}>
                <Box sx={styleModalAgregar}>
                    <AsociadoFormComponent onClose={handleCloseModalAgregarInstalacion} actualizarZonas={props.actualizarZonas} asociados={asociados} asociadoModify={null} zona={zona} localidad={localidad} sublocalidad={sublocalidad} actualizarAsociadosLocalidad={actualizarAsociadosLocalidad} handleCloseModalAsociados={props.handleCloseModalAsociados} handleCloseModalAgregarInstalacion={handleCloseModalAgregarInstalacion} />
                </Box>
            </Modal>
        )
    }

    const modalReagendarDiasDelAsociado = () => {
        return (
            <Modal
                open={openModalReagendarDiasDelAsociado}
                onClose={handleCloseModalReagendarDiasDelAsociado}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                <Box sx={styleModalDias}>
                    <DiasDeLaLocalidadComponent localidad={localidad} asociado={asociadoAux} />
                </Box>
            </Modal>
        )
    }

    const modalVerInfoDelAsociado = () => {
        return (
            <Modal style={{ backgroundColor: 'transparent !important' }}
                open={openModalVerInfoDelAsociado}
                onClose={handleCloseModalVerInfoDelAsociado}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                <Box sx={styleModalVerInfoDelAsociado}>
                    <VerInfoDelAsociadoComponent localidad={localidad} asociado={asociadoAux} handleCloseModalVerInfoDelAsociado={handleCloseModalVerInfoDelAsociado} />
                </Box>
            </Modal>
        )
    }

    const bg = {
        overlay: {
            background: "#FFFF00"
        }
    };

    const modalActivarAsociado = () => {
        return (
            <Modal
                open={openModalActivarAsociado}
                onClose={handleCloseModalActivarAsociado}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">

                <Box sx={styleModalConfirmacion} styles={bg}>
                    <h3>Activar Usuario</h3>
                    Estás seguro de querer activar este usuario? <br></br>

                    <button onClick={() => activarUsuario(asociadoAux)} className='btn btn-success'>Si, estoy seguro</button>
                </Box>
            </Modal>
        )
    }

    return (
        <Fragment>
            <div className='row mb-2'>
                <div className='col-md-10'>

                </div>
                <div className='col-md-2'>
                <button onClick={() => handleOpenModalAgregarInstalacion()} className='btn btn-success'>Añadir asociado</button>

                </div>

            </div>
            {
                asociados.map((asociado, index) => (
                    <AsociadoItemComponent key={index} asociado={asociado}
                        handleOpenModalActivarAsociado={handleOpenModalActivarAsociado}
                        handleOpenModalDesvincularAsociado={handleOpenModalDesvincularAsociado}
                        handleOpenModalReagendarDiasDelAsociado={handleOpenModalReagendarDiasDelAsociado}
                        handleOpenModalVerInfoDelAsociado={handleOpenModalVerInfoDelAsociado}
                        handleCloseModalAsociados={props.handleCloseModalAsociados}
                        actualizarZonas={props.actualizarZonas}
                    ></AsociadoItemComponent>
                ))
            }
            {modalVerInfoDelAsociado()}
            {modalReagendarDiasDelAsociado()}
            {modalDesvincularAsociado()}
            {modalActivarAsociado()}
            {modalAgregarInstalacionAsociado()}
        </Fragment >
    )
}

export default AsociadosDeLaLocalidadListComponent